import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapLoaderService } from './amap-loader.service';
import { LoggerService } from './logger/logger.service';
import { Getter } from '../base/interfaces';

const TAG = 'AMap';

@Injectable()
export class AMapService implements Getter<AMap.Map> {
  private map: AMap.Map;
  private map$ = new ReplaySubject<AMap.Map>();

  constructor(
    private loader: AMapLoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åå°å¾å¯¹è±¡ AMap.Map
   */
  get() {
    return this.map$.asObservable();
  }

  /**
   * åå»ºå°å¾å¯¹è±¡ AMap.Map
   * @param container å°å¾å®¹å¨çDOMåç´ 
   * @param options éé¡¹
   */
  create(container: HTMLElement, options: AMap.Map.Options) {
    return this.loader.load().pipe(
      map(() => {
        this.map = this.ngZone.runOutsideAngular(() => new AMap.Map(container, options));
        this.logger.d(TAG, 'new map created.');
        this.map$.next(this.map);
        this.map$.complete();
        return this.map;
      }),
    );
  }

  /**
   * éæ¯å°å¾å¯¹è±¡
   */
  destroy() {
    this.get().subscribe(m => {
      m.destroy();
      this.logger.d(TAG, 'map destroyed.');
      this.map = null;
    });
  }
}
